module.exports = __webpack_public_path__ + "img/IMG_7242.e8e608b5.jpg";